import React from "react";

const RoleWrapper = ({ allowedRoles = [], denyRoles = [], userRole, children }) => {
  // Verifica si el rol del usuario está en la lista de roles denegados
  if (denyRoles.includes(userRole)) {
    return null;
  }

  // Verifica si el rol del usuario está en la lista de roles permitidos
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return null;
  }

  // Renderiza los hijos si pasa las verificaciones
  return <>{children}</>;
};

export default RoleWrapper;